import styled from 'styled-components';

const FileInput = styled.input.attrs({
  type: 'file',
  accept: 'image/jpeg, image/png',
})`
  position: absolute;
  display: block;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  opacity: 0;
  cursor: pointer;
`;

export default FileInput;
